// libraries
import React, { useState } from 'react'
import clsx from 'clsx'

// svg
import { External } from '/react4xp/components/Svg/Ux/Ux'

// utils
import { isNonWhitespaceString, replaceSpaces } from '/lib/reactutils/utils.js'

export interface MaritimePartnerCardProps {
    isAlwaysOpen?: boolean
    companyName?: string
    location?: {
        country?: string
        city?: string
        fullAddress?: string
    }
    phones?: Array<{
        phone: string
        sector?: string
    }>
    emails?: Array<{
        email: string
        sector?: string
    }>
    website?: string
    operations?: Array<string>
}

export default function MaritimePartnerCard({
    isAlwaysOpen,
    companyName,
    location,
    phones,
    emails,
    website,
    operations
}: MaritimePartnerCardProps) {

    const [isActive, setIsActive] = useState(false)

    const toggleState = () => {
        setIsActive(prevState => !prevState)
    }

    const Element = isAlwaysOpen ? 'div' : 'button'
    
    return (
        <div className={clsx(
            'maritime-partner-card',
            isAlwaysOpen && 'always-open',
            isActive && 'active'
        )}>
            
            <Element
                className='maritime-partner-card__title'
                onClick={!isAlwaysOpen ? toggleState : null}
            >

                <span className='title-infos-left'>

                    {isNonWhitespaceString(companyName) && (
                        <span className='text-lg company-name'>
                            {companyName}
                        </span>
                    )}

                    {isNonWhitespaceString(location.country || location.city) && (
                        <span className='location'>
                            {location.city && location.city + ', '}
                            {location.country && location.country}
                        </span>
                    )}

                </span>

                <span className='title-icon'>
                    <span></span>
                    <span></span>
                </span>

            </Element>

            <div className='maritime-partner-card__wrapper'>
                <div>
                    <div className='wrapper-cols'>

                        <div className='wrapper-left'>

                            {phones && phones.length > 0 && phones.map((item, i) => (
                                <a
                                    href={`tel:${replaceSpaces(item.phone)}`}
                                    key={i}
                                >
                                    {item.phone} {item.sector && `(${item.sector})`}
                                </a>
                            ))}

                            {emails && emails.length > 0 && emails.map((item, i) => (
                                <a
                                    href={`mailto:${item.email}`}
                                    key={i}
                                >
                                    {item.email} {item.sector && `(${item.sector})`}
                                </a>
                            ))}

                            {isNonWhitespaceString(website) && (
                                <a
                                    href={website.startsWith('http') ? website : `https://${website}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    {website} <External />
                                </a>
                            )}

                        </div>

                        <div className='wrapper-right'>
                            
                            {operations && operations.length > 0 && (
                                <>

                                    <p className='label'>
                                        Operations
                                    </p>

                                    {operations.map((item, i) => (
                                        <p key={i} className='item'>
                                            {item}
                                        </p>
                                    ))}

                                </>
                            )}

                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}